import React from 'react'
import {
  CustomerUserAuditSnapshotV1,
  IAuditEventData,
  PermissionCheckAuditSnapshotV1,
} from '../../../api'
import { useDetailStyles } from './useDetailStyles'
import { Box } from 'cs-kevlar-react'
import { UnavailableDetails } from './UnavailableDetails'
import { resolveEventData, resolveSnapshots } from './utils'
import { DetailField } from './DetailField'

interface CustomerUserDetailsProps {
  eventData: IAuditEventData
}

export const CustomerUserDetails: React.FunctionComponent<CustomerUserDetailsProps> = ({
  eventData,
}) => {
  const classes = useDetailStyles()
  const [originalSnapshot, updatedSnapshot] = resolveSnapshots<
    CustomerUserAuditSnapshotV1
  >(eventData, nameof<CustomerUserAuditSnapshotV1>())

  const permissionCheck = resolveEventData<PermissionCheckAuditSnapshotV1>(
    eventData,
    nameof<PermissionCheckAuditSnapshotV1>(),
  )

  if (!updatedSnapshot && !originalSnapshot && !permissionCheck)
    return <UnavailableDetails />

  const showDiff = !!originalSnapshot && !!updatedSnapshot

  return (
    <React.Fragment>
      {!!permissionCheck && (
        <Box className={classes.fieldsContainer}>
          <DetailField
            label="Document Type"
            original={permissionCheck.documentType}
          />

          <DetailField
            label="Search Field"
            original={permissionCheck.targetField}
          />

          <DetailField
            label="Search Value"
            original={permissionCheck.targetFieldValue}
          />
        </Box>
      )}

      {!permissionCheck && (
        <Box className={classes.fieldsContainer}>
          <DetailField
            label="Name"
            showDiff={showDiff}
            original={originalSnapshot?.fullName}
            updated={updatedSnapshot?.fullName}
          />

          <DetailField
            label="Username"
            showDiff={showDiff}
            original={originalSnapshot?.username}
            updated={updatedSnapshot?.username}
          />

          <DetailField
            label="Phone"
            showDiff={showDiff}
            original={originalSnapshot?.phone}
            updated={updatedSnapshot?.phone}
          />

          <DetailField
            label="Email"
            showDiff={showDiff}
            original={originalSnapshot?.email}
            updated={updatedSnapshot?.email}
          />
        </Box>
      )}
    </React.Fragment>
  )
}
